// BCC-side mirror of the portal's MODULES registry.
//
// The portal (bullogic-client-portal repo) is the source of truth for
// what modules actually exist — each entry there has a React component
// that renders the form. BCC just needs labels + section so the read-only
// PortalTab summary can show friendly names instead of raw `module_key`
// strings.
//
// Synchronization rule: when you add a module in the portal's
// src/modules/registry.js, mirror an entry here. The two will diverge
// otherwise — the activity row in BCC will fall back to the raw slug.
//
// Eventually this could move to a portal /api/modules endpoint BCC
// queries at runtime, but that's overhead for a list that changes maybe
// once a month. The hand-mirror is fine until module count is >10.
//
// Note (2026-05): module *pushing* moved to the portal admin
// (PORTAL_ADMIN_BRIEF.md). BCC no longer has a picker. This registry
// is now display-only — used to label rows in PortalTab's activity
// summary. The `section` field is kept for future use; nothing in BCC
// reads it today.

export const PORTAL_MODULES = {
  onboarding_questionnaire: {
    label: 'Document Organizer',
    section: 'dashboard',
    description: 'Captures personal + financial baseline for new clients.',
  },
  account_setup: {
    label: 'Account Setup',
    section: 'dashboard',
    description: 'Sign engagement letter + set up Stripe billing (combined step 1).',
  },
  // Mirror future portal modules here as they ship in src/modules/registry.js
  // over in the portal repo.
};

// Sections in the portal's left rail. Kept for future use; the BCC
// PortalTab summary doesn't group by section today (it just lists most
// recent activity).
export const PORTAL_SECTIONS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'fsp',       label: 'Financial Success Plan' },
  { key: 'rental',    label: 'Rental' },
  { key: 'business',  label: 'Business' },
  { key: 'tax_plan',  label: 'Tax Plan' },
];

// Look up the friendly label for a module_key. Falls back to the raw key
// if the module isn't in this registry (e.g., a module that was pushed
// before it was removed from the portal codebase). Lets the UI render
// history rows for deleted modules gracefully.
export function moduleLabel(moduleKey) {
  return PORTAL_MODULES[moduleKey]?.label || moduleKey;
}

export function moduleSection(moduleKey) {
  return PORTAL_MODULES[moduleKey]?.section || 'dashboard';
}
